import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'easyPayStopPage'
}

export const createSchema = (t: TFunction) => {
  return z.object({
    authorization: z.literal(true, {
      // Zod doesn't currently support shorthand messages for `invalid_literal`
      errorMap: () => ({ message: t('authorization.validation', tConfig) })
    })
  })
}

export type EasyPayStopFormData = z.infer<ReturnType<typeof createSchema>>
